/**
 * VAT Price Toggle
 * File: assets/vat-toggle.js
 *
 * Prices stored in Shopify are INCLUSIVE of VAT.
 * Ex-VAT price is reverse-calculated by dividing by (1 + VAT rate).
 */
 
(function () {
  const STORAGE_KEY = 'vatToggleIncVat';
  const DEFAULT_VAT_RATE = 0.20;
 
  function getVatRate() {
    const wrapper = document.getElementById('vat-toggle-wrapper');
    if (wrapper && wrapper.dataset.vatRate) {
      return parseFloat(wrapper.dataset.vatRate);
    }
    return DEFAULT_VAT_RATE;
  }
 
  function formatMoney(cents, currency) {
    const amount = cents / 100;
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: currency || 'GBP',
    }).format(amount);
  }
 
  function updatePrices(showIncVat) {
    const vatRate = getVatRate();
    const priceEls = document.querySelectorAll('[data-price-inc-vat]');
 
    priceEls.forEach(function (el) {
      const incVatCents = parseInt(el.dataset.priceIncVat, 10);
      const currency = el.dataset.currency || 'GBP';
      if (isNaN(incVatCents)) return;
 
      const exVatCents = Math.round(incVatCents / (1 + vatRate));
      el.textContent = formatMoney(showIncVat ? incVatCents : exVatCents, currency);
 
      const noteEl = el.closest('.price-wrapper') && el.closest('.price-wrapper').querySelector('.vat-price-note');
      if (noteEl) {
        noteEl.textContent = showIncVat
          ? formatMoney(exVatCents, currency) + ' ex. VAT'
          : formatMoney(incVatCents, currency) + ' inc. VAT';
      }
    });
  }
 
  function init() {
    // Run initial price update based on saved preference
    var saved = localStorage.getItem(STORAGE_KEY);
    var showIncVat = saved === null ? true : saved === 'true';
    updatePrices(showIncVat);
 
    // Listen for toggle changes dispatched by vat-toggle.liquid
    document.addEventListener('vatToggleChange', function () {
      var current = localStorage.getItem(STORAGE_KEY);
      updatePrices(current === 'true');
    });
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();